import React, { useEffect, useState } from "react";
import { getCategories } from "../../api/categoryService";
import "../../assets/css/CategoryList.css";
import { FaPlus, FaEye, FaEdit, FaImage } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "../../utils/errorHandler";
import { exportCategories } from "../../api/categoryService";

export default function CategoryList() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchCategories = async () => {
    try {
      setLoading(true);
      const res = await getCategories();
      // SAFE DATA HANDLING
      const data = res?.data?.data || res?.data || [];
      setCategories(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to fetch categories", error);
      alert(getErrorMessage(error));
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCategories();
  }, []);

  const handleExportCategories = async () => {
    try {
      const response = await exportCategories();

      const blob = new Blob([response.data], {
        type: "text/csv",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      // Get filename from response header if available
      const contentDisposition = response.headers["content-disposition"];

      let fileName = "categories.csv";

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match?.[1]) {
          fileName = match[1];
        }
      }

      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert(getErrorMessage(error));
    }
  };
  return (
    <div className="container-fluid p-4 np-categories-page">
      <div className="card p-3">
        <div className="d-flex align-items-center justify-content-end gap-2 pb-3">
          <button className="btn btn-success" onClick={handleExportCategories}>
            Export CSV
          </button>

          <button
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={() => navigate("/category/add")}
          >
            <FaPlus />
            Add Category
          </button>
        </div>
        {loading && <p>Loading categories...</p>}
        {!loading && categories.length === 0 && (
          <p className="text-secondary">No categories found</p>
        )}
        <div className="row">
          {categories.map((cat) => (
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4" key={cat._id}>
              <div className="card border-0 shadow-sm np-category-card">
                <div className="np-category-card__image">
                  {cat?.seo?.metaImageUrl ? (
                    <img src={cat.seo.metaImageUrl} alt={cat.name || "Category"} loading="lazy" />
                  ) : (
                    <div className="np-category-card__placeholder" aria-hidden="true">
                      <FaImage />
                    </div>
                  )}

                  <div className="np-category-card__actions">
                    <button
                      type="button"
                      className="btn btn-light btn-sm np-category-card__action"
                      title="View"
                      aria-label={`View ${cat.name || "category"}`}
                      onClick={() => navigate(`/category/view/${cat?.seo?.slug}`)}
                    >
                      <FaEye />
                    </button>
                    <button
                      type="button"
                      className="btn btn-light btn-sm np-category-card__action"
                      title="Edit"
                      aria-label={`Edit ${cat.name || "category"}`}
                      onClick={() =>
                        navigate(`/category/edit/${cat?.seo?.slug}`, {
                          state: {
                            slug: cat?.seo?.slug,
                            categoryId: cat._id,
                          },
                        })
                      }
                    >
                      <FaEdit />
                    </button>
                  </div>
                </div>

                <div className="card-body d-flex flex-column ">
                  <h5 className="card-title mb-2 np-category-card__title">
                    {cat.name || "Untitled category"}
                  </h5>
                  <p className="card-text text-muted np-category-card__description">
                    {cat.description || "No description available"}
                  </p>
                  <p className="mb-2 np-category-card__tagline">
                    <strong>Tagline:</strong> {cat.tagline || "No tagline"}
                  </p>
                  <p className="fw-medium mb-0 np-category-card__status">
                    Status: {cat.status || "Inactive"}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
